import React from 'react';
// TODO: (D.K.) Necessary make refactoring of this part of the functionality is needed (to get rid of react-redux)
// eslint-disable-next-line no-restricted-imports
import { useSelector } from 'react-redux';
import { ImageError } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
// TODO: (D.K.) need to get rid of the use of store and redux (selectors) in Atoms components
import { getCommonLabels } from '@yme/selectors/common';
import { colorCoreBlack300, colorCoreGray1000Base, colorCoreGray300, colorCoreWhite1000, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { IconWrapperStyled, PlaceholderContentStyled, PlaceholderStyled } from './styled';
export function ImageErrorPlaceholder({ withText = false, aspectRatio = AspectRatio.RectangleLevel3, hasBackground = false, fallbackImageAltText = '', backgroundColor = colorCoreGray300, }) {
    // TODO: (D.K.) need to get rid of the use of store and redux in Atoms components (Necessary use 'labels' from props)
    const commonLabels = useSelector(getCommonLabels);
    const fallBackText = fallbackImageAltText || commonLabels?.common_fallbackImage_altText;
    const iconFill = hasBackground ? colorCoreWhite1000 : colorCoreGray1000Base;
    return (React.createElement(PlaceholderStyled, { aspectRatio: aspectRatio, backgroundColor: backgroundColor },
        React.createElement(PlaceholderContentStyled, null,
            React.createElement(IconWrapperStyled, { hasBackground: hasBackground },
                React.createElement(SVGIcon, { type: ImageError, pathFill: iconFill })),
            withText && (React.createElement(FlexWrapper, { mt: INDENT.xxxs },
                React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, fallBackText))))));
}
ImageErrorPlaceholder.displayName = 'ImageErrorPlaceholder_Atom';
